import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import { FormPublishStatus } from "../../utils/formBuilderUtils";
import { Dialog, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppDispatch } from "../../redux/hooks";
import { cloneTemplate, deleteTemplate } from "../../redux/entities/formBuilderEntity";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import useModalStrip from "../../global-hooks/useModalStrip";

const newFormLayout = {
  border: "1px dashed",
  width: "50px",
  height: "50px",
  fontSize: "2.7rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  borderRadius: "9px",
};
const textboxStyle = {
  minWidth: "100%",
  maxWidth: "100%",
  marginTop: "20px",
};

const FormLayoutComponent = ({ template, createdFormLayout, setOpenDialog }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [openToClone, setOpenToClone] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const { showModalStrip } = useModalStrip();
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [creatingForm, setCreatingForm] = useState(false);

  const [newFormData, setNewFormData] = useState({
    formName: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check if form name is empty
    if (newFormData?.formName.trim() === "") {
      showModalStrip("danger", "Form name cannot be empty", 5000);
      return;
    }

    setCreatingForm(true);
    try {
      let formData = new FormData();
      let isFileAttached = false
      let dataToSend = {
        formName: newFormData.formName
      }

      if (uploadedFileName) {
        isFileAttached = true;
        formData.append("logo", uploadedFileName);
        formData.append("templateData", JSON.stringify(dataToSend))
      } else {
        formData = dataToSend;
      }

      // Dispatch the cloneTemplate action with FormData
      const response = await dispatch(cloneTemplate({ isFileAttached, id: template?.id, formData })).unwrap();

      if (response) {
        // Reload the page on successful response
        setOpenToClone(false);
      }
    } catch (ex) {
      showModalStrip("danger", "Error occurred while creating a new Form", 5000);
    } finally {
      setCreatingForm(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      const url = URL.createObjectURL(file);
      setFileUrl(url);
      setUploadedFileName(file); // Store the file object instead of the name
    }
  };

  return (
    <div
      className="col"
      style={{
        border: "2px solid black",
        borderRadius: "10px",
        padding: "10px",
        backgroundColor: "#96c9ff38",
      }}
    >
      <div
        className={`${createdFormLayout ? "created-form-layout" : "new-form-layout"
          } d-flex flex-column`}
      >
        <div style={{ width: "50px", height: "100%" }}>
          <div
            style={
              createdFormLayout
                ? {
                  ...newFormLayout,
                  width: "100%",
                  border: "1px solid",
                }
                : newFormLayout
            }
            onClick={() => {
              if (createdFormLayout && template) {
                navigate(`/form-builder/${template?.id}`);
              } else {
                setOpenDialog?.(true); // Ensure setOpenDialog is defined
              }
            }}
          >
            <i
              className={`fas ${createdFormLayout ? "fa-journal-whills" : "fa-plus"
                }`}
            ></i>
          </div>
        </div>

        <h5
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
          }}
          className={`mt-3 template-name ${template?.publishStatus === FormPublishStatus.PUBLISHED
            ? "text-success"
            : ""
            }`}
        >
          {createdFormLayout ? template?.formName : "Blank Form"}
        </h5>

        {createdFormLayout && (
          <div className="delete_btn">
            <IconButton
              style={{ color: "rgb(170 9 9)", outline: "none" }}
              aria-label="delete"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete the template?")) {
                  dispatch(deleteTemplate(template?.id));
                }
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              style={{ color: "rgb(170 9 9)", outline: "none" }}
              aria-label="clone"
              onClick={() => {
                setOpenToClone(true)
              }}
            >
              <FileCopyIcon />
            </IconButton>
          </div>
        )}

        {openToClone &&
          <Dialog
            open={openToClone}
            fullWidth
            maxWidth="lg"
            onClose={() => {
              setOpenToClone(false);
            }}
          >
            <DialogTitle>
              <div className="d-flex align-items-center justify-content-between">
                <span
                  style={{ padding: "9px", cursor: "pointer" }}
                  onClick={() => setOpenToClone(false)}
                >
                  <i className="fas fa-arrow-left"></i>
                </span>
                <span
                  style={{ padding: "9px", cursor: "pointer" }}
                  onClick={() => setOpenToClone(false)}
                >
                  <i className="fas fa-times"></i>
                </span>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="p-30" style={{ minHeight: "500px" }}>
                <div
                  style={{
                    maxWidth: "360px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <h4>Enter the following details to create clone:</h4>
                  <form onSubmit={handleFormSubmit} style={{ minWidth: "100%" }}>
                    <div>
                      <TextField
                        label="Form Name"
                        name="formName"
                        value={newFormData.formName}
                        onChange={handleInputChange}
                        style={textboxStyle}
                        required
                      />
                    </div>
                    {/* {=====================add logo input=================} */}
                    <div className="mt-4">
                      <h4>Upload Logo:</h4>
                      <input
                        id="file-upload"
                        style={{ display: "none" }}
                        type="file"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="file-upload"
                        className="control-input-trigger-buttons"
                        style={{ cursor: "pointer" }} // Optional: Adds a pointer cursor for better UX
                      >
                        <i className="fas fa-cloud-upload-alt"></i>
                      </label>
                      {uploadedFileName && (
                        <>
                          <p>Uploaded File: {uploadedFileName.name}</p>
                          <img src={fileUrl} alt="Uploaded" width={150} height={150} />
                        </>
                      )}
                    </div>
                    {/* {=====================end logo input=================} */}

                    <button
                      className="btn btn-light btn-shadow m-t-20 m-r-10"
                      type="submit"
                      disabled={creatingForm}
                    >
                      {creatingForm ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading
                        </>
                      ) : (
                        "Create Form"
                      )}
                    </button>
                    <input
                      type="button"
                      className="btn btn-light btn-shadow m-t-20 m-l-0"
                      value="Cancel"
                      disabled={creatingForm}
                      onClick={() => setOpenToClone(false)}
                    />
                  </form>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        }

      </div>
    </div>
  );
};

export default FormLayoutComponent;
